import { z } from "zod";

import { machineSchema } from "./machine";
import { PORT_MAX, PORT_MIN } from "./constants";

const trackConfigurationSchema = z.object({}).passthrough();

const machineAlarmSchema = z.object({}).passthrough();

const unitOfMeasureSchema = z.enum(["Metric", "UsCustomary"]);
export const x7MachineRequestSchema = z.object({
	alias: z.string().optional(),
	description: z.string().optional(),
	ipOrDnsName: z.string().optional(),
	port: z.number().min(PORT_MIN).max(PORT_MAX).optional(),
	tracks: z.array(trackConfigurationSchema).optional(),
});

export const x7MachineSchema = machineSchema.extend({
	unitOfMeasurement: unitOfMeasureSchema.optional(),
	stopReason: machineAlarmSchema.optional(),
});

export type X7Machine = z.infer<typeof x7MachineSchema>;
export type X7MachineRequest = z.infer<typeof x7MachineRequestSchema>;
